import {
  BaseCarouselProps,
  CarouselBase,
  IProps as CarouselBaseIProps,
} from "@faire/retailer-visitor-shared/components/LayoutElementRenderer/__internal__/Carousel/CarouselBase";
import { Context } from "@faire/retailer-visitor-shared/components/LayoutElementRenderer/__internal__/Context";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { BrandReviewWithCommentTile } from "@faire/retailer-visitor-shared/views/suppliers/__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/LoggedOutSuppliersPage/__internal__/Components/LoggedOutSuppliersPageBrandReviewTile/BrandReviewWithCommentTile";
import { isNotUndefined } from "@faire/web--source/common/typescriptUtils";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { trackSeoSuppliersPageMostPopularCarouselView } from "@faire/web-api--source/events/seo/view/suppliersPageMostPopularCarousel";
import { IBrandReviewTile } from "@faire/web-api--source/indigofair/data/IBrandReviewTile";
import React from "react";

const MAX_ITEMS_MOBILE = 1;
const MAX_ITEMS_DESKTOP = 3;

export const MostPopularBrandsCarousel: React.FC<BaseCarouselProps> = ({
  ...props
}) => {
  const CarouselBaseComponent = CarouselBase as React.ComponentType<
    CarouselBaseIProps<IBrandReviewTile>
  >;
  const { layoutElement, requestId, onItemClick, onVisible } =
    React.useContext(Context);
  const { isMobile } = useViewport();
  const renderTile = (brandReviewTile: IBrandReviewTile) => {
    return (
      <BrandReviewWithCommentTile
        key={brandReviewTile.brand_token}
        item={brandReviewTile}
        onClick={(token) => {
          if (layoutElement.on_click_event_name) {
            onItemClick?.(layoutElement.on_click_event_name, requestId, token);
          }
        }}
      />
    );
  };

  const onItemsVisible = (items: IBrandReviewTile[]) => {
    trackSeoSuppliersPageMostPopularCarouselView();
    const itemTokens = items
      .map((item) => item.brand_token)
      .filter(isNotUndefined);
    if (layoutElement.on_click_event_name) {
      onVisible?.(
        layoutElement.on_click_event_name,
        requestId,
        itemTokens?.join(" ") ?? ""
      );
    }
  };

  const getItems = () => {
    return layoutElement.layout_element_data
      .map((elementData) => elementData.brand_review_tile)
      .filter(isNotUndefined);
  };

  return (
    <CarouselBaseComponent
      renderItem={renderTile}
      items={getItems()}
      itemsPerSlide={{
        mobileAndAbove: MAX_ITEMS_MOBILE,
        tabletAndAbove: MAX_ITEMS_DESKTOP,
      }}
      peekNext={isMobile}
      peekNextPercent={{
        mobileAndAbove: 25,
        tabletAndAbove: 0,
      }}
      itemGap={16}
      onItemsVisible={(items: IBrandReviewTile[]) => {
        trackSeoSuppliersPageMostPopularCarouselView();
        onItemsVisible(items);
      }}
      {...props}
    />
  );
};
